/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SeasonSpecialLinkBundle {
    WHATS_APP = 'WhatsApp',
    TELEGRAM = 'Telegram',
}
